import { ImportRowValidation } from "../DataImport.types";

/**
 * The rows that actually reach definition.onImport: the user's selection
 * intersected with rows that passed validation. Shared by the footer button
 * label, the step-2 gate and ImportProgressStep so they cannot diverge.
 */
export const getImportableRows = (
  rows: ImportRowValidation[],
  selectedRowIndexes: Set<number>
): ImportRowValidation[] =>
  rows.filter((r) => selectedRowIndexes.has(r.rowIndex) && r.isValid);
